var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipamentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24.375,
    viewBox: "0 0 30 24.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_134",
    "data-name": "Uni\\xE3o 134",
    d: "M19.688,24.375v-.938H10.312v.938H4.687v-.938H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H26a4,4,0,0,1,4,4V19.437a4,4,0,0,1-4,4h-.687v.938ZM.938,18.5a4,4,0,0,0,4,4H25.062a4,4,0,0,0,4-4V5.625H.938ZM2.813,9.375a.938.938,0,0,1,0-1.876H27.187a.938.938,0,0,1,0,1.876Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipamentos);
export default __webpack_public_path__ + "static/media/equipamentos.ee3f5e4c6ca91dddf6ce62e6055e6520.svg";
export { ForwardRef as ReactComponent };